import { useCallback, useState } from "react";
import { FaEye, FaEyeSlash, FaKey, FaLock } from 'react-icons/fa';
import sulogLogo from '../../assets/images/logoMobile.svg';
import sulogLogin from '../../assets/images/sulog_login.svg';
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "../../services/api";
import './Login.css';

const RedefinicaoSenha = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Código pré-preenchido quando o usuário chega pelo link do e-mail
  // (aceita ?codigo= ou ?token=).
  const [token, setToken] = useState(
    searchParams.get('codigo') || searchParams.get('token') || ''
  );
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async (token: string, password: string, confirmPassword: string) => {
    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }

    try {
      setLoading(true);

      const body = {
        codigo: token,
        nova_senha: password,
      };
      const response = await api.post("/autenticar/redefinirSenhaComCodigo", body);
      
      if (response.status === 200) {
        toast.success("Senha atualizada com sucesso!");
        navigate("/");
      }

      setLoading(false);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Erro ao redefinir a senha. Tente novamente.";
      toast.error(errorMessage);
      setLoading(false);
    }
  }, [navigate]);

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="logo-container">
          <img src={sulogLogin} alt="SULOG Logo" className="logo" />
          <h1>SULOG</h1>
          <p>Pátio de Triagem</p>
        </div>
      </div>
      <div className="login-right relative">
        {loading && (
          <div className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-white/85 backdrop-blur-xs transition-all">
            <div className="w-10 h-10 border-4 border-[#003366] border-t-transparent rounded-full animate-spin"></div>
            <span className="text-sm font-semibold text-[#003366] mt-3">Carregando...</span>
          </div>
        )}
        <img src={sulogLogo} alt="SULOG Logo" className="logoMobile" />
        <form className="login-form" onSubmit={(e) => { e.preventDefault(); handleSubmit(token, password, confirmPassword) }}>
          <div className="form-group">
            <label htmlFor="token">Codigo de verificação</label>
            <div className="input-icon">
              <FaKey className="icon" />
              <input type="text" id="token" name="token" value={token} onChange={(e) => setToken(e.target.value)} required />
            </div>
          </div>
          <div className={`form-group ${error ? 'error' : ''}`}>
            <label htmlFor="password">Nova senha</label>
            <div className="input-icon">
              <FaLock className="icon" />
              <input type={showPassword ? "text" : "password"} id="password" name="password" onChange={(e) => setPassword(e.target.value)} required />
              <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
          <div className={`form-group ${error ? 'error' : ''}`}>
            <label htmlFor="confirmPassword">Confirmar nova senha</label>
            <div className="input-icon">
              <FaLock className="icon" />
              <input type={showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" onChange={(e) => setConfirmPassword(e.target.value)} required />
              <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {error && <p className="error-message">{error}</p>}
          </div>
          <div className="form-group form-inline">
            <button type="submit" className="login-button">Salvar</button>
          </div>
        </form>
        <footer>
          <a href="/terms" className="terms-link">Termos de uso e política de privacidade</a>
          <p>Versão 2.0</p>
        </footer>
      </div>
    </div>
  );
};

export default RedefinicaoSenha;
